import React from "react";
import "./Header.css";
function Header({ name, size, onClose }) {
    function convertBytesToKBMBGB(bytes) {
        if (bytes < 1024) {
          return bytes + " B";
        } else if (bytes < 1024 * 1024) {
          return (bytes / 1024).toFixed(2) + " KB";
        } else if (bytes < 1024 * 1024 * 1024) {
          return (bytes / (1024 * 1024)).toFixed(2) + " MB";
        } else {
          return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
        }
      }
  return (
    <div className="document-picker_header">
      <div className="document-picker_heading">
        <div className="document-picker_content">
          <div className="document-picker_header_name">{name}</div>
          <div className="document-picker_header_size">{convertBytesToKBMBGB(size)}</div>
        </div>
      </div>
      <div className="document-picker_close">
        <span class="material-symbols-outlined" onClick={() => onClose()}>close</span>
      </div>
    </div>
  );
}

export default Header;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/ImageLibrary/Header.js